import { MemberGroups } from "shared-types";
import authorizationService from "../services/authorization/authorizationService";

export function checkIsAgent() {
  return authorizationService.getUserGroup() === MemberGroups.agent;
}
